interface props {
  buttonLabel: string;
  isLoading: boolean;
}

const SubmitButton = ({ buttonLabel, isLoading }: props) => {
  return (
    <button
      type="submit"
      className="bg-violet-500 text-white p-3 px-5 rounded-md sm:text-sm md:text-base flex items-center justify-center gap-2"
    >
      {isLoading ? (
        <>
          Loading
          <div className="w-5 h-5 border-4 border-t-violet-500 rounded-full animate-spin"></div>
        </>
      ) : (
        buttonLabel
      )}
    </button>
  );
};

export default SubmitButton;
